import { render, staticRenderFns } from "./InsuredStatement.vue?vue&type=template&id=4538b464&scoped=true"
import script from "./InsuredStatement.vue?vue&type=script&lang=js"
export * from "./InsuredStatement.vue?vue&type=script&lang=js"
import style0 from "./InsuredStatement.vue?vue&type=style&index=0&id=4538b464&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4538b464",
  null
  
)

export default component.exports